Calculator = {}

$(function () {
    var xhr;
    var select_mark, $select_mark;
    var select_model, $select_model;
    var select_generation, $select_generation;
    var select_serie, $select_serie;
    var select_modification, $select_modification;
    var firstLoad = true;
    $select_mark = $('.mark-depend[name="mark"]').selectize({
        placeholder: "Выберите марку...",
        preload: true,
        valueField: "id",
        labelField: "name",
        searchField: ["name"],
        load: function (query, callback) {
            xhr && xhr.abort();
            xhr = $.ajax({
                url: '/api/v1/marks',
                type: 'GET',
                dataType: 'json',
                success: function (result) {
                    callback(result);
                    // set previously selected mark as active if exists
                    var markId = $("[name='calc[mark]']").val();
                    if (markId !== '') {
                        $select_mark[0].selectize.setValue(markId);
                    }
                },
                error: function () {
                    callback();
                }
            });
        },
        onChange: function (value) {
            if (!value.length) return;

            discardChangedOptions('models', $selects, selectList);

            select_model.load(function (callback) {
                xhr && xhr.abort();
                xhr = $.ajax({
                    method: "POST",
                    dataType: "JSON",
                    url: "/api/v1/models",
                    data: "mark=" + value + "&_csrf=" + $("#_csrf").val(),
                    success: function (results) {
                        select_model.enable();
                        callback(results);

                        if (results.length === 1) {
                            select_model.setValue(results[0].id);
                        } else if ($('input[name="calc[model]"]').val() > 0) {
                            select_model.setValue($('input[name="calc[model]"]').val());
                        }
                        let fadeIn = 100;
                        let fadeOut = 100;
                        if (firstLoad) {
                            fadeIn = 0;
                            fadeOut = 0;
                            firstLoad = false;
                        }
                        setCalcBackground(value, fadeIn, fadeOut);
                    },
                    error: function () {
                        callback();
                    }
                });

            });
        }
    });

    $select_model = $('.model-depend[name="model"]').selectize({
        placeholder: "Выберите модель...",
        valueField: "id",
        labelField: "name",
        searchField: ["name"],
        onChange: function (value) {
            if (!value.length) return;

            discardChangedOptions('generations', $selects, selectList);

            if (select_generation != undefined) {
                select_generation.load(function (callback) {
                    xhr && xhr.abort();
                    xhr = $.ajax({
                        method: "POST",
                        dataType: "JSON",
                        url: "/api/v1/generations",
                        data: "model=" + value + "&_csrf=" + $("#_csrf").val(),
                        success: function (results) {
                            select_generation.enable();
                            callback(results);
                            if (results.length === 1) {
                                select_generation.setValue(results[0].id);
                            } else if ($('input[name="calc[generation]"]').val() > 0) {
                                select_generation.setValue($('input[name="calc[generation]"]').val());
                            }
                        },
                        error: function () {
                            callback();
                        }
                    });

                });
            }
        }
    });

    $select_generation = $(".generation-depend").selectize({
        placeholder: "Выберите год...",
        valueField: "id",
        labelField: "name",
        searchField: ["name"],
        onChange: function (value) {
            if (!value.length) return;

            var model_val = $(".model-depend").val();

            discardChangedOptions('series', $selects, selectList);

            select_serie.load(function (callback) {
                xhr && xhr.abort();
                xhr = $.ajax({
                    method: "POST",
                    dataType: "JSON",
                    url: "/api/v1/series",
                    data: "model=" + model_val + "&generation=" + value + "&_csrf=" + $("#_csrf").val(),
                    success: function (results) {
                        select_serie.enable();
                        callback(results);
                        if (results.length === 1) {
                            select_serie.setValue(results[0].id);
                        } else if ($('input[name="calc[serie]"]').val() > 0) {
                            select_serie.setValue($('input[name="calc[serie]"]').val());
                        }
                    },
                    error: function () {
                        callback();
                    }
                });

            });
        }
    });

    $select_serie = $(".serie-depend").selectize({
        placeholder: "Выберите тип кузова...",
        valueField: "id",
        labelField: "name",
        searchField: ["name"],
        onChange: function (value) {
            if (!value.length) return;

            var model_val = $(".model-depend").val();

            discardChangedOptions('modifications', $selects, selectList);

            select_modification.load(function (callback) {
                xhr && xhr.abort();
                xhr = $.ajax({
                    method: "POST",
                    dataType: "JSON",
                    url: "/api/v1/modifications",
                    data: "model=" + model_val + "&serie=" + value + "&_csrf=" + $("#_csrf").val(),
                    success: function (results) {
                        select_modification.enable();
                        callback(results);
                        if (results.length === 1) {
                            select_modification.setValue(results[0].id);
                        } else if ($('input[name="calc[modification]"]').val() > 0) {
                            select_modification.setValue($('input[name="calc[modification]"]').val());
                        }
                    },
                    error: function () {
                        callback();
                    }
                });

            });
        }
    });

    $select_modification = $(".modification-depend").selectize({
        placeholder: "Выберите модификацию....",
        valueField: "id",
        labelField: "name",
        searchField: ["name"],
    });
    if ($select_mark[0] !== undefined &&
        $select_model[0] !== undefined &&
        $select_generation[0] !== undefined &&
        $select_serie[0] !== undefined &&
        $select_modification[0] !== undefined) {
        var $selects = {
            'marks': $select_mark[0].selectize,
            'models': $select_model[0].selectize,
            'generations': $select_generation[0].selectize,
            'series': $select_serie[0].selectize,
            'modifications': $select_modification[0].selectize,
        };
        var selectList = [
            'marks',
            'models',
            'generations',
            'series',
            'modifications',
        ];
    }

    if ($select_serie[0] !== undefined)
        select_serie = $select_serie[0].selectize;
    if ($select_modification[0] !== undefined)
        select_modification = $select_modification[0].selectize;
    if ($select_generation[0] !== undefined)
        select_generation = $select_generation[0].selectize;
    if ($select_model[0] !== undefined)
        select_model = $select_model[0].selectize;
    if ($select_mark[0] !== undefined)
        select_mark = $select_mark[0].selectize;

    $("select:not(.selectpicker, .not-selectize)").selectize();

    if ($('input[name="calc[mark]"]').val() > 0) {
        select_mark.setValue($('input[name="calc[mark]"]').val());
    }

    if (!($(".generation-depend").val() > 0) && select_generation !== undefined)
        select_generation.disable();

    if (!($(".modification-depend").val() > 0) && select_modification !== undefined)
        select_modification.disable();

    if (!($(".serie-depend").val() > 0) && select_serie !== undefined)
        select_serie.disable();

    if (!($(".model-depend").val() > 0) && select_model !== undefined) {
        select_model.disable();
    }

    initSelectpickerDropdownOnClickEvent();

    $(".dropdown-toggle + .dropdown-menu").perfectScrollbar();

    $(".calc-types input[name=\'services[]\']").on("click", function () {
        if (this.checked) {
            $(".param.service-" + $(this).val()).show();
            $(".param.service-" + $(this).val() + " .dropdown-menu.inner").perfectScrollbar();
        } else
            $(".param.service-" + $(this).val()).hide();
    });

    $(".selectpicker.metro").selectpicker({
        noneSelectedText: "Выберите метро"
    });

    // load and create service list
    $.ajax({
        url: '/api/v1/services',
        type: 'GET',
        dataType: 'json',
        success: function (result) {
            result.forEach(function (service) {
                var serviceElement = '';
                var subServiceElements = '';
                var checked = '';
                var isHidden = ' is-hidden';
                if (service.checked) {
                    checked = 'checked';
                    isHidden = '';
                }
                serviceElement += '<div class="b-form_checkbox">';
                serviceElement += '<input id="services-' + service.id + '" type="checkbox" name="services[]"' +
                    '                                               value="' + service.id + '" ' + checked + '>';
                serviceElement += '<label for="services-' + service.id + '">' + service.service_name + '</label>';
                serviceElement += '</div>';

                subServiceElements += '<div class="param service-' + service.id + isHidden + '">';
                subServiceElements += '<input type="hidden" name="calc[service]" value="">';
                subServiceElements += '<select class="selectpicker" name="service[]" multiple>';
                service.children.forEach(function (subService) {
                    if (subService.lvl === 2) {
                        return;
                    }
                    selected = '';
                    if (subService.checked) {
                        selected = 'selected';
                    }
                    subServiceElements += '<option value="' + subService.id + '" ' + selected + '>';
                    subServiceElements += subService.name;
                    subServiceElements += '</option>';
                });
                subServiceElements += '</select>';
                subServiceElements += '</div>';

                $(".calc-types").prepend(serviceElement);
                $(".calc-params").prepend(subServiceElements);

                $(".selectpicker").selectpicker({noneSelectedText: 'Выберите услугу'});

                initServiceCheckbox();
                initSelectpickerDropdownOnClickEvent();
                $(".dropdown-toggle + .dropdown-menu").perfectScrollbar();
            });
        },
        error: function () {
            console.log('error when loading services');
        }
    });

    if ($('[data-show-block="tabs"]').length) {
        // Tabs
        var tabsWrap = $('.b-tabs_wrapper');
        var serviceList = [];

        // calculator submit event
        $('[data-show-block="tabs"]').on('click', function (e) {

            if ($('#mark-id').val() > 0 && $('#model-id').val() > 0 && $('input[name="services[]"]:checked').length > 0 && (!$(".calc-params .param.paramed").is(':visible') || ($(".calc-params .param.paramed").is(':visible') && $('#package-id').val() > 0 && $('#oil-id').val() > 0))) {

                var services = [];
                var mainServices = [];
                var serviceParam;
                var mainServiceParam;
                $.each($("select[name='service[]']"), function () {
                    services = $.merge($(this).val(), services);
                });
                serviceParam = services.join(',');
                $.each($("input[name='services[]']:checked"), function () {
                    mainServices = $.merge([$(this).val()], mainServices);
                });
                mainServiceParam = mainServices.join(',');

                var params = "?active=Y";
                if ($('#mark-id').val() != undefined && $('#mark-id').val() != '') {
                    params = params + "&mark=" + $('#mark-id').val()
                }
                if ($('#model-id').val() != undefined && $('#model-id').val() != '') {
                    params = params + "&model=" + $('#model-id').val()
                }
                if ($('#generation-id').val() != undefined && $('#generation-id').val() != '') {
                    params = params + "&generation=" + $('#generation-id').val()
                }
                if ($('#serie-id').val() != undefined && $('#serie-id').val() != '') {
                    params = params + "&serie=" + $('#serie-id').val()
                }
                if ($('#modification-id').val() != undefined && $('#modification-id').val() != '') {
                    params = params + "&modification=" + $('#modification-id').val()
                }
                if (serviceParam != undefined && serviceParam != '') {
                    params = params + "&service=" + serviceParam
                }
                if (mainServiceParam != undefined && mainServiceParam != '') {
                    params = params + "&main_service=" + mainServiceParam
                }
                params = params + "&_csrf=" + $("#_csrf").val();

                if ($('.calc-params .param.paramed').is(":visible")) {
                    params += "&package=" + $('#package-id').val() + "&oil=" + $('#oil-id').val();
                }

                if ($('.widget-calc').length) {
                    params += "&calc=1";
                } else {
                    params += "&calc=0";
                }


                $('.b-tabs_wrapper').remove();
                $('#tabs').html('<div class="b-tabs_wrapper"></div>');
                $('.b-tabs_wrapper').css({'height': 0, overflow: 'hidden'});
                $('.b-tabs_wrapper').load('/api/v1/price-list' + params, function () {
                    $('.b-tabs_wrapper').css({'height': 'auto'});
                    $(this).responsiveTabs({startCollapsed: 'accordion'});

                    var sum = 0;
                    $('.total-cost').each(function () {
                        var num = $(this).html();
                        num = num.replace(/от/g, '');
                        num = num.replace(/руб/g, '');
                        num = num.replace(/\./g, '');
                        num = num.replace(/\s/g, '');
                        num = num.replace(/,/g, '.');
                        sum += Number(num)
                    });


                    if ($('.calc-price').hasClass('is-hidden')) {
                        $('.calc-price').removeClass('is-hidden').find('.b-inner').html('Стоимость услуг: <strong></strong>');
                    }

                    $('.calc-price .b-inner strong').text(number_format(sum, 2, ',', ' ') + ' руб.');

                });

            } else {
                if ($("#mark-id").val() == 0)
                    showSelectizeError("mark-id", "Необходимо выбрать марку автомобиля");

                if ($("#model-id").val() == 0)
                    showSelectizeError("model-id", "Необходимо выбрать модель автомобиля");
                // if($("#generation-id").val() == 0)
                //     showSelectizeError("generation-id", "Необходимо выбрать год");

                // if($("#serie-id").val() == 0)
                //     showSelectizeError("serie-id", "Необходимо выбрать тип кузова");

                // if($("#modification-id").val() == 0)
                //     showSelectizeError("modification-id", "Необходимо выбрать модификацию");

                if ($('input[name="services[]"]:checked').length == 0) {
                    var element = $('input[name="services[]"]');
                    if (!element.hasClass("error")) {
                        $('#services').html("<label id=\"services-error\" class=\"error\" for=\"services\">Необходимо выбрать вид ремонта</label>");
                        element.addClass("error");
                        element.on('click change focus', function () {
                            $("#services-error").remove();
                            $('input[name="services[]"]').removeClass("error");
                        });
                    }
                }

                if ($(".calc-params").is(':visible')) {
                    if ($("#package-id").val() == 0)
                        showSelectizeError("package-id", "Необходимо выбрать пакет ТО");

//                    if($("#engine-id").val() == 0)
//                        showSelectizeError("engine-id", "Необходимо выбрать тип двигателя");

                    if ($("#oil-id").val() == 0)
                        showSelectizeError("oil-id", "Необходимо выбрать масло");
                }
            }

            e.preventDefault();
        });

    } else {
        if (typeof tabsWrap !== 'undefined') {
            initTabs();
        }
    }

    resetCalcHandler($selects);
});

function alignServices(serviceSelectors) {
    $(serviceSelectors).each(function () {
        var val = parseInt($(this).val());
        var minus = 135;
        $(this).prop("checked", true);
        $(".param.service-" + $(this).val()).css({
            top: $(this).parent().find("label").offset().top - 25,
            position: "absolute"
        });
        $(".param.service-" + $(this).val()).show();
    });
}

function preload(images) {
    if (typeof document.body == "undefined") return;
    try {
        var div = document.createElement("div");
        $(div).addClass("preloaded");
        var s = div.style;
        s.position = "absolute";
        s.top = s.left = 0;
        s.visibility = "hidden";
        $(".b-wrapper").append(div);
        div.innerHTML = '<img src="' + images.join("' /><img src = '") + '" />';
        var lastImg = div.lastChild;
        lastImg.onload = function () {
            $(".b-wrapper .preloaded").remove();
        };
    } catch (e) {
        // Error. Do nothing.
        console.log(e);
    }
}

function initServiceCheckbox() {
    $(".calc-types input[name='services[]']").on("click", function () {
        var val = parseInt($(this).val());
        var minus = 135;
        if (jQuery.inArray(val, services_with_params) != -1)
            minus = 115

        if (this.checked) {
            $(".param.service-" + $(this).val()).css({
                top: $(this).parent().find("label").offset().top - 75,
                position: "absolute"
            });
            $(".param.service-" + $(this).val()).show();
            $(".param.service-" + $(this).val() + " .dropdown-menu.inner").perfectScrollbar();
        } else
            $(".param.service-" + $(this).val()).hide();
    });
}

function initSelectpickerDropdownOnClickEvent() {
    $(".show-tick, .btn-group").click(function (event) {
        $(this).toggleClass("open");
        event.stopPropagation();
    });
    $(document).click(function (event) {
        $(".show-tick, .btn-group").removeClass("open");
    });
}

function discardChangedOptions(currentOption, $selects, selectList = []) {
//    discard marks, models, generations, series, modifications
    let discard = false;
    selectList.forEach(function (option) {
        if (option == currentOption) {
            discard = true;
        }
        if (discard && $selects[option] != undefined) {
            $selects[option].disable();
            $selects[option].clearOptions();
        }
    })
}

function initTabs() {
    tabsWrap.responsiveTabs({
        startCollapsed: 'accordion',
    });
}

function showSelectizeError(id, error) {

    if (error === undefined) {
        error = 'Необходимо заполнить данное поле';
    }

    var element = $("#" + id).next().find('.selectize-input');
    if (!element.hasClass("error")) {
        element.after("<label id=\"" + id + "-error\" class=\"error\" for=\"" + id + "\">" + error + "</label>");
        element.addClass("error");
        element.on('click change focus', function () {
            $("#" + id + "-error").remove();
            $(this).removeClass("error");
        });
    }
}

function resetCalcHandler($selects) {
    $('#reset-calc').click(function (event) {
        event.stopPropagation();

        $.ajax({
            'async': false,
            'global': false,
            'url': "/api/clear-calc-session",
            'dataType': "json",
            'success': function (data) {
                if (data === 'ok') {
                    $selects['modifications'].setValue(0);
                    $selects['series'].setValue(0);
                    $selects['generations'].setValue(0);
                    $selects['models'].setValue(0);
                    $selects['marks'].setValue(0);

                    $selects['modifications'].disable();
                    $selects['series'].disable();
                    $selects['generations'].disable();
                    $selects['models'].disable();

                    $('.selectpicker[name="service[]"]').selectpicker('deselectAll');
                    $('.calc-types input[type=checkbox]:checked').prop('checked', false);
                    $('.service-3, .service-4').hide();

                    // $('.m-result-table').hide();
                }
            }
        });

        return false;
    });
}

function setCalcBackground(value = 0, fadeInValue = 0, fadeOutValue = 0) {

    if ($.inArray(parseInt(value), [0, 2, 10, 18, 35, 37, 42, 51, 61, 63, 76, 79, 80, 89, 92, 97, 99, 113, 116, 123, 127, 130, 135, 139, 147, 159, 166, 167, 176, 184, 185]) === -1) {
        value = 0;
    }

    var image = $('#bgImageMarkAuto');
    image.fadeOut(fadeOutValue, function () {
        image.attr('data-src', '/images/content/mark/' + value + '.jpg')
        image.fadeIn(fadeInValue);
    });
}

if ($('input[name="calc[mark]"]').length > 0) {
    setCalcBackground($('input[name="calc[mark]"]').val());
}
